<template>
  <div v-if="rabotaruIsBroken">
    <VCard
      :timeout="-1"
      :value="true"
      class="cabinet-card"
      outlined
    >
      <VCardText class="mb-1 mt-1">
        <div style="color: red">
          <div>
            <span>
              К сожалению, нам не удалось обновить токен авторизации на Rabota.ru Интеграция сейчас остановлена. Для возобновления интеграции сделайте следующее:
            </span>
          </div>
          <ol>
            <li>Разлогиньтесь на <a target="_blank" href="https://cabinet.huntica.works">cabinet.huntica.works</a></li>
            <li>На сайте <a target="_blank" href="https://rabotaru.huntica.works/#order">https://rabotaru.huntica.works/#order</a> нажмите на кнопку "Подключить видеособеседования на rabota.ru"</li>
          </ol>
        </div>
      </VCardText>
    </VCard>
  </div>
</template>

<script>
import { useI18n } from 'vue-i18n-composable';
import useCompany from '@/compositions/useCompany';
import { ref } from '@vue/composition-api';

export default {
  name: 'RabotaruTokenExpiredBar',
  setup() {
    const { locale } = useI18n();
    const { getIntegrationTokenStatus } = useCompany();
    const rabotaruIsBroken = ref(false);

    async function fetchRabotaruIsBroken() {
      if (locale.value.toLowerCase() === 'ru') {
        const rabotaruStatus = await getIntegrationTokenStatus('rabotaru');
        rabotaruIsBroken.value = rabotaruStatus.isBroken;
      }
    }

    return {
      fetchRabotaruIsBroken,
      rabotaruIsBroken,
    };
  },
  async created() {
    await this.fetchRabotaruIsBroken();
  },
};
</script>

<style lang="scss" scoped>
.cabinet-card.v-card {
  background: #FFFFFF;
  box-shadow: 0px 2px 8px rgba(0, 0, 0, 0.16);
  border-radius: 10px;
  padding: 0;
  .btn-close {
    z-index: 2;
  }
}
</style>

<i18n locale="en" lang="yaml">
verifyEmail: Verify your e-mail address
emailNotRecieved: E-mail not received
resend: Resend
verificationEmailSent: Verification e-mail was sent
</i18n>

<i18n locale="ru" lang="yaml">
verifyEmail: Подтвердите свой e-mail адрес
emailNotRecieved: Не пришло письмо
resend: Отправить еще раз
verificationEmailSent: Письмо для подтверждения E-mail отправлено
</i18n>
